import { TFunction } from "i18next";

/** Maps API default item-category titles (English) to i18n keys. */
const DEFAULT_ITEM_CATEGORY_I18N_KEYS: Record<string, string> = {
  "ENGINE OIL": "itemCategoryEngineOil",
  "BRAKE PADS": "itemCategoryBrakePads",
  "BRAKE DISC / ROTOR": "itemCategoryBrakeDiscRotor",
  "TRANSMISSION OIL": "itemCategoryTransmissionOil",
  "ENGINE AIR FILTER": "itemCategoryEngineAirFilter",
  "CABIN FILTER": "itemCategoryCabinFilter",
  BATTERY: "itemCategoryBattery",
  "TYRE REPLACEMENT": "itemCategoryTyreReplacement",
  "TIRE REPLACEMENT": "itemCategoryTyreReplacement",
  COOLANT: "itemCategoryCoolant",
  "TIMING BELT": "itemCategoryTimingBelt",
  "SPARK PLUGS": "itemCategorySparkPlugs",
  "DRIVE BELT / SERPENTINE BELT": "itemCategoryDriveBelt",
  "BRAKE FLUID": "itemCategoryBrakeFluid",
  "POWER STEERING FLUID": "itemCategoryPowerSteeringFluid",
  "SUSPENSION INSPECTION": "itemCategorySuspensionInspection",
  "OIL FILTER": "itemCategoryOilFilter",
  OTHER: "itemCategoryOther",
};

export function normalizeItemCategoryTitle(title?: string | null) {
  return String(title || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, " ");
}

export function getItemCategoryI18nKey(title?: string | null) {
  return (
    DEFAULT_ITEM_CATEGORY_I18N_KEYS[normalizeItemCategoryTitle(title)] || null
  );
}

/** Translate known default categories; leave custom titles unchanged. */
export function translateItemCategoryTitle(
  title: string | undefined | null,
  t: TFunction,
) {
  if (!title) return "";
  const key = getItemCategoryI18nKey(title);
  return key ? t(key) : title;
}

export function isEngineOilCategory(category: any) {
  const raw = category?.title || category?.label || "";
  return normalizeItemCategoryTitle(raw) === "ENGINE OIL";
}
